const keycloakConfig = {
    "realm": process.env.REACT_APP_KEYCLOAK_REALM,
    "url": process.env.REACT_APP_KEYCLOAK_URL,
    "ssl-required": "external",
    "clientId": process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
    "public-client": true,
    "confidential-port": 0
};

export default keycloakConfig;

